/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { TerminalProvider } from "@lemmonhq/types";
import { TERMINAL_PROVIDERS } from "./providerConfig";
import { ProviderLogo } from "./ProviderLogo";

type ProviderPickerProps = {
  value: TerminalProvider;
  onChange: (provider: TerminalProvider) => void;
};

/** Provider tiles, only shown when creating a terminal. */
export const ProviderPicker = defineComponent<ProviderPickerProps>({
  name: "TerminalProviderPicker",
  props: ["value", "onChange"],
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <div class="space-y-2">
        <span class="text-sm font-medium text-base-content/80">
          {t("settings.terminals.provider")}
        </span>
        <div class="grid grid-cols-2 gap-2">
          {TERMINAL_PROVIDERS.map((provider) => {
            const selected = props.value === provider.value;
            return (
              <button
                key={provider.value}
                type="button"
                aria-pressed={selected}
                class={`flex min-h-14 items-center gap-3 rounded-xl border-2 px-3 py-2 text-left transition-colors ${
                  selected
                    ? "border-primary bg-primary/5"
                    : "border-base-300 hover:border-base-content/30"
                }`}
                onClick={() => props.onChange(provider.value)}
              >
                <ProviderLogo provider={provider.value} size="sm" />
                <span class="flex-1 text-sm font-medium text-base-content">
                  {provider.label}
                </span>
                {selected && (
                  <span class="material-symbols-outlined text-lg text-primary">
                    check_circle
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    );
  },
});
